import React, { Component } from "react";
import Landing from "./LandingContainer";
import { LANDING_MENU_BAR } from "../../constants/strings/StringsDashboard";
import Form, { formTypes } from "../../Forms/Containers/FormCreator";

import MapsList from "../containers/MapsListContainer";

class LoadMapContainer extends Component {
  state = {
    form: {},
    table: false,
    content: [
      {
        name: "Mapa1",
        type: "kml",
        size: "100",
        lastModified: "26/01/2021",
      },
      {
        name: "Mapa2",
        type: "kml",
        size: "100",
        lastModified: "26/01/2021",
      },
    ],
  };
  handlerChange = (variable, value) => {
    console.log("Variables y valores");
    console.log(variable, value);
    this.setState({
      form: {
        ...this.state.form,
        [variable]: value,
      },
    });
  };

  handlerSubmit = () => {
    console.log("ACA VA EL NODO");
    console.log(this.state.form);
    console.log(this.state.content);
    let name= this.state.form.mapName
    let type= this.state.form.mapFile

    console.log(type.type)
    console.log(type.size)
    console.log(type.lastModified)
    const lastModify = new Date(type.lastModified)
    let varia = this.state.content
    varia.push(
      {
        name: name,
        type: type.type,
        size: type.size,
        lastModified: `${lastModify.getDate()}/${lastModify.getMonth() + 1}/${lastModify.getFullYear()}`,
      }
    )
    // let size= this.state.form.mapName
    // let lastModified= this.state.form.mapName
    console.log(name);
    console.log(type);
    // this.setState.content.push(this.state.form);
    this.setState({ table: true });
    return false;
  };

  // updateListTable = () =>{
  //   return <MapsList/>
  // }

  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <div>
          <h1 className="page-title">{LANDING_MENU_BAR.LOAD_MAP}</h1>
        </div>
        <div>
          <div className="container-content">
            <div className="content-line">
              <Form
                onChange={this.handlerChange}
                objectCreator={[
                  {
                    type: formTypes.div,
                    classContainer: "line line-100",
                  },
                  {
                    type: formTypes.div,
                    classContainer: "line line-10",
                  },
                  {
                    type: formTypes.attach,
                    classContainer: "line line-40",
                    // classInput: "form-control",
                    classLabel: "input-text",
                    label: "Adjuntar archivo KML - KMZ",
                    // placeholder: "Ingrese por favor el barrio del hecho",
                    required: true,
                    btnLabel: "Seleccionar archivo",
                    variable: "mapFile",
                    // value: '',
                  },
                  // {
                  //   type: formTypes.div,
                  //   classContainer: "line line-10",
                  // },
                  {
                    type: formTypes.text,
                    classContainer: "line line-40",
                    // classInput: "form-control",
                    classLabel: "input-text",
                    label: "Nombre del archivo",
                    placeholder:
                      "Ingrese el nombre con el que se identifica el mapa",
                    required: true,
                    variable: "mapName",
                    // value: '',
                  },
                  {
                    type: formTypes.div,
                    classContainer: "line line-10",
                  },
                  {
                    type: formTypes.div,
                    classContainer: "line line-100",
                  },
                  {
                    type: formTypes.div,
                    classContainer: "line line-20 ",
                  },
                  {
                    // type: formTypes.click,
                    type: formTypes.submit,
                    classContainer:
                      "button-primary line line-20 text-center center-content",
                    label: "Cargar",
                    placeholder: "-",
                  },
                  {
                    type: formTypes.div,
                    classContainer: "line line-20",
                  },
                  {
                    type: formTypes.click,
                    classContainer:
                      "button-secondary line line-20 text-center center-content",
                    label: "Cancelar",
                    placeholder: "-",
                  },
                  {
                    type: formTypes.div,
                    classContainer: "line line-20",
                  },
                ]}
                onSubmit={this.handlerSubmit}
                // onSubmit={this.updateListTable}
                values={this.state.form}
              />
              {/* {this.updateListTable} */}
            </div>
          </div>
          {this.state.table && <MapsList content={this.state.content} />}
        </div>
      </Landing>
    );
  }
}

export default LoadMapContainer;
